import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=45eebb2a&scoped=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=45eebb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eebb2a",
  null
  
)

export default component.exports